/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_Picker_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Search members…" |
*
* @param {User_Picker_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const user_picker_placeholder = /** @type {((inputs?: User_Picker_PlaceholderInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Picker_PlaceholderInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Rechercher des membres…")
	if (locale === "es") return /** @type {LocalizedString} */ ("Buscar miembros…")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Buscar membros…")
	if (locale === "it") return /** @type {LocalizedString} */ ("Cerca membri…")
	return /** @type {LocalizedString} */ ("Search members…")
});